import { css } from '@emotion/react';

export const containerStyle = (isEnhancedFlowEnabled: boolean) => css`
  margin: ${isEnhancedFlowEnabled ? 0 : `var(--fabric-space-padding-md) 0`};
`;
